import { gql } from '@apollo/client';

export default gql`
  mutation deleteInspectionSubject($id: ID!) {
    deleteInspectionSubject(input: { id: $id }) {
      success
    }
  }
`;
